// extracted by mini-css-extract-plugin
export default {"timer":"SgPOG","timerPartContainer":"_BoTW","delimiter":"oxJmd","timerPart":"VNvuB","timerCount":"DE_aV","timerUnit":"QzT1h"};